module.exports = __webpack_public_path__ + "img/8b46a12.png";